import { useEffect } from 'react'

const RECENT_KEY = 'devhub:recent'
const MAX_RECENT = 5

export function getRecentTools(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? (parsed as string[]) : []
  } catch {
    return []
  }
}

export function addRecentTool(toolId: string): void {
  try {
    const current = getRecentTools().filter(id => id !== toolId)
    const updated  = [toolId, ...current].slice(0, MAX_RECENT)
    localStorage.setItem(RECENT_KEY, JSON.stringify(updated))
  } catch { /* ignore */ }
}

/**
 * Call this hook at the top of every tool page to record it as recently used.
 */
export function useRecentTools(toolId: string): void {
  useEffect(() => {
    addRecentTool(toolId)
  }, [toolId])
}
